(() => {
  if (window.republicCartInitialized) return;
  window.republicCartInitialized = true;

  const base = window.Shopify?.routes?.root || '/';
  let busy = false;
  let previousFocus = null;
  let previousOverflow = '';
  let cartData = null;
  let successNoticeTimer = null;
  let successNoticeVersion = 0;

  const style = document.createElement('style');
  style.textContent = `
    #RepublicBag[hidden], #RepublicBag [hidden] { display: none !important; }
    #RepublicBag { position: fixed; inset: 0; z-index: 10000; color: #343c2c; }
    #RepublicBag .rb-backdrop { position: absolute; inset: 0; background: rgba(20,24,16,.55); }
    #RepublicBag .rb-panel {
      position: absolute; right: 0; top: 0; box-sizing: border-box;
      width: min(460px,100%); height: 100%; height: 100dvh; max-height: 100%;
      overflow: hidden; background: #f2e8d5; display: flex; flex-direction: column;
      box-shadow: -12px 0 40px rgba(0,0,0,.18); animation: rb-enter .25s ease-out;
    }
    #RepublicBag .rb-top {
      display: flex; align-items: center; justify-content: space-between; flex: 0 0 auto;
      padding: 20px 24px; padding-top: max(16px,env(safe-area-inset-top)); border-bottom: 1px solid #a47b4b66;
    }
    #RepublicBag h2 { font-family: var(--heading,Georgia,serif); font-size: 28px; margin: 0; color: #343c2c; }
    #RepublicBag button { cursor: pointer; border-radius: 0; font: inherit; }
    #RepublicBag .rb-close { background: none; border: none; color: #343c2c; font-size: 28px; width: 44px; height: 44px; flex-shrink: 0; }
    #RepublicBag .rb-items { flex: 1 1 0; min-height: 0; overflow-y: auto; padding: 0 24px; overscroll-behavior: contain; -webkit-overflow-scrolling: touch; }
    #RepublicBag .rb-item { display: grid; grid-template-columns: 90px minmax(0,1fr); gap: 16px; padding: 24px 0; border-bottom: 1px solid #a47b4b55; }
    #RepublicBag .rb-item > div { min-width: 0; overflow-wrap: anywhere; }
    #RepublicBag .rb-item img { width: 90px; height: 90px; object-fit: contain; background: #f5f0e6; }
    #RepublicBag .rb-name { font-family: var(--heading,Georgia,serif); font-size: 19px; line-height: 1.3; text-decoration: none; color: #343c2c; }
    #RepublicBag .rb-detail { font-size: 13px; margin: 6px 0; }
    #RepublicBag .rb-price { margin: 8px 0; }
    #RepublicBag .rb-controls { display: flex; align-items: center; flex-wrap: wrap; gap: 8px; }
    #RepublicBag .rb-quantity { display: flex; align-items: center; border: 1px solid #a47b4b88; }
    #RepublicBag .rb-quantity button { width: 44px; height: 44px; border: 0; background: transparent; color: #343c2c; }
    #RepublicBag .rb-quantity span { min-width: 28px; text-align: center; }
    #RepublicBag .rb-remove { border: 0; background: none; text-decoration: underline; color: #343c2c; min-height: 44px; }
    #RepublicBag .rb-bottom { flex: 0 0 auto; background: #f2e8d5; padding: 24px; padding-bottom: calc(20px + env(safe-area-inset-bottom)); border-top: 1px solid #a47b4b66; }
    #RepublicBag .rb-subtotal { display: flex; justify-content: space-between; flex-wrap: wrap; gap: 16px; font-size: 19px; margin-bottom: 14px; }
    #RepublicBag .rb-note { font-size: 12px; margin: 0 0 18px; line-height: 1.5; }
    #RepublicBag .rb-checkout { display: flex; justify-content: center; align-items: center; box-sizing: border-box; min-height: 50px; padding: 14px 12px; width: 100%; background: #343c2c; color: #f2e8d5; text-decoration: none; text-align: center; border: 1px solid #a47b4b; letter-spacing: .08em; font-size: 13px; }
    #RepublicBag .rb-continue { display: block; width: 100%; min-height: 44px; margin-top: 12px; padding: 10px; background: transparent; border: 0; color: #343c2c; font-size: 12px; letter-spacing: .08em; }
    #RepublicBag .rb-message { flex: 0 0 auto; max-height: 72px; overflow-y: auto; overflow-wrap: anywhere; padding: 12px 24px; margin: 0; font-size: 14px; }
    #RepublicBag .rb-message:empty { display: none; }
    #RepublicBag .rb-empty { padding: 50px 0; text-align: center; font-family: var(--heading,Georgia,serif); font-size: 23px; }
    #RepublicBag button:disabled { opacity: .45; cursor: not-allowed; }
    #RepublicBag :focus-visible { outline: 3px solid #a47b4b; outline-offset: 3px; }
    @keyframes rb-enter { from { transform: translateX(100%); } to { transform: translateX(0); } }
    @media (max-width: 380px) {
      #RepublicBag .rb-top, #RepublicBag .rb-items, #RepublicBag .rb-message, #RepublicBag .rb-bottom { padding-left: 16px; padding-right: 16px; }
    }
    @media (max-width: 749px) {
      #RepublicBag .rb-item { grid-template-columns: 72px minmax(0,1fr); gap: 12px; padding: 18px 0; }
      #RepublicBag .rb-item img { width: 72px; height: 72px; object-fit: contain; }
      #RepublicBag .rb-name { font-size: 17px; line-height: 1.35; overflow-wrap: break-word; }
      #RepublicBag .rb-detail { margin: 4px 0; font-size: 12px; line-height: 1.4; }
      #RepublicBag .rb-price { margin: 6px 0 8px; font-size: 14px; line-height: 1.4; }
      #RepublicBag .rb-controls { gap: 6px; }
      #RepublicBag .rb-quantity button { width: 44px; height: 44px; min-width: 44px; min-height: 44px; padding: 0; }
      #RepublicBag .rb-remove { min-width: 44px; min-height: 44px; padding: 8px; }
    }
    @media (max-height: 600px) {
      #RepublicBag .rb-top { padding-top: max(8px,env(safe-area-inset-top)); padding-bottom: 8px; }
      #RepublicBag .rb-bottom { padding-top: 12px; padding-bottom: calc(12px + env(safe-area-inset-bottom)); }
      #RepublicBag .rb-note { margin-bottom: 10px; }
      #RepublicBag .rb-continue { margin-top: 6px; }
    }
    @media (prefers-reduced-motion: reduce) { #RepublicBag .rb-panel { animation: none; } }
  `;
  document.head.appendChild(style);

  const drawer = document.createElement('div');
  drawer.id = 'RepublicBag';
  drawer.hidden = true;
  drawer.innerHTML = `
    <div class="rb-backdrop" data-rb-close></div>
    <div class="rb-panel" role="dialog" aria-modal="true" aria-labelledby="RepublicBagTitle" tabindex="-1">
      <div class="rb-top">
        <h2 id="RepublicBagTitle">YOUR BAG</h2>
        <button type="button" class="rb-close" aria-label="Close your bag" data-rb-close>×</button>
      </div>
      <p class="rb-message" role="status" aria-live="polite" hidden></p>
      <div class="rb-items"></div>
      <div class="rb-bottom">
        <div class="rb-subtotal" hidden><span>Subtotal</span><strong data-rb-total></strong></div>
        <p class="rb-note" hidden>Shipping, taxes and any additional discounts are calculated at checkout.</p>
        <a class="rb-checkout" href="${base}checkout" hidden>SECURE CHECKOUT →</a>
        <button type="button" class="rb-continue" data-rb-close>CONTINUE SHOPPING</button>
      </div>
    </div>
  `;
  document.body.appendChild(drawer);

  const panel = drawer.querySelector('.rb-panel');
  const items = drawer.querySelector('.rb-items');
  const message = drawer.querySelector('.rb-message');
  const checkout = drawer.querySelector('.rb-checkout');
  const inertElements = new Map();

  function cancelSuccessNotice() {
    clearTimeout(successNoticeTimer);
    successNoticeTimer = null;
    successNoticeVersion += 1;
  }
  function setMessage(text) {
    message.textContent = text;
    message.hidden = !text;
  }
  function showSuccessNotice(text, productStatus = null) {
    cancelSuccessNotice();
    const version = successNoticeVersion;
    setMessage(text);
    if (productStatus) {
      productStatus.hidden = false;
      productStatus.textContent = text;
    }
    successNoticeTimer = setTimeout(() => {
      if (version !== successNoticeVersion) return;
      if (message.textContent === text) setMessage('');
      if (productStatus && productStatus.textContent === text) {
        productStatus.textContent = '';
        productStatus.hidden = true;
      }
      successNoticeTimer = null;
    }, 2500);
  }
  function money(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency', currency: cartData?.currency || 'USD'
    }).format(cents / 100);
  }
  function safeURL(value) {
    if (!value) return '';
    try {
      const url = new URL(value, location.origin);
      return ['http:', 'https:'].includes(url.protocol) ? url.href : '';
    } catch { return ''; }
  }
  function openDrawer() {
    if (!drawer.hidden) return;
    previousFocus = document.activeElement;
    previousOverflow = document.body.style.overflow;
    drawer.hidden = false;
    document.body.style.overflow = 'hidden';
    Array.from(document.body.children).forEach(element => {
      if (element !== drawer && element instanceof HTMLElement) {
        inertElements.set(element, element.inert);
        element.inert = true;
      }
    });
    drawer.querySelector('.rb-close').focus();
  }
  function closeDrawer() {
    if (drawer.hidden) return;
    drawer.hidden = true;
    document.body.style.overflow = previousOverflow;
    inertElements.forEach((value, element) => { element.inert = value; });
    inertElements.clear();
    if (previousFocus?.isConnected) previousFocus.focus();
  }
  async function request(path, options = {}) {
    const response = await fetch(base + path, {
      ...options,
      headers: { Accept: 'application/json', ...(options.headers || {}) }
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Please try again.');
    return data;
  }

  // Keep the First Drop selector tied to its existing form and variant limits.
  function syncDropQuantity(form) {
    const input = form?.querySelector('.republic-quantity input[name="quantity"]');
    if (!input) return;
    const selected = form.querySelector('select[name="id"]')?.selectedOptions[0];
    const unavailable = selected?.dataset.available === 'false';
    const minimum = Math.max(1, Number(input.min) || 1);
    const step = Number(input.step) || 1;
    const value = input.valueAsNumber;
    const maximum = input.max === '' ? Infinity : Number(input.max);
    const minus = form.querySelector('[data-republic-quantity="-1"]');
    const plus = form.querySelector('[data-republic-quantity="1"]');
    if (minus) minus.disabled = busy || unavailable || !Number.isFinite(value) || value <= minimum;
    if (plus) plus.disabled = busy || unavailable || !Number.isFinite(value) || value + step > maximum;
  }
  function syncAllDropQuantities() {
    document.querySelectorAll('#first-drop form').forEach(syncDropQuantity);
  }
  function setBusy(value) {
    busy = value;
    if (value) cancelSuccessNotice();
    panel.setAttribute('aria-busy', String(value));
    drawer.querySelectorAll('[data-rb-change]').forEach(button => {
      button.disabled = value || button.dataset.rbLimit === 'true';
    });
    checkout.setAttribute('aria-disabled', String(value));
    syncAllDropQuantities();
  }

  function renderCart(cart) {
    cartData = cart;
    const focusKey = document.activeElement?.dataset?.rbFocus;
    items.replaceChildren();
    document.querySelectorAll('[data-count]').forEach(element => {
      element.textContent = cart.item_count;
    });
    drawer.querySelector('[data-rb-total]').textContent = money(cart.total_price);
    checkout.hidden = cart.item_count === 0;
    drawer.querySelector('.rb-subtotal').hidden = cart.item_count === 0;
    drawer.querySelector('.rb-note').hidden = cart.item_count === 0;
    if (!cart.items.length) {
      const empty = document.createElement('p');
      empty.className = 'rb-empty';
      empty.textContent = 'Your bag is waiting for its first piece of Texas.';
      items.appendChild(empty);
    }
    cart.items.forEach(item => {
      const row = document.createElement('div');
      row.className = 'rb-item';
      const image = document.createElement('img');
      const imageURL = safeURL(item.image);
      if (imageURL) image.src = imageURL;
      image.alt = item.product_title;
      image.loading = 'lazy';
      row.appendChild(image);
      const content = document.createElement('div');
      const name = document.createElement('a');
      name.className = 'rb-name';
      name.href = safeURL(item.url);
      name.textContent = item.product_title;
      content.appendChild(name);
      if (item.variant_title && item.variant_title !== 'Default Title') {
        const variant = document.createElement('p');
        variant.className = 'rb-detail';
        variant.textContent = item.variant_title;
        content.appendChild(variant);
      }
      if (item.selling_plan_allocation) {
        const plan = document.createElement('p');
        plan.className = 'rb-detail';
        plan.textContent = item.selling_plan_allocation.selling_plan.name;
        content.appendChild(plan);
      }
      Object.entries(item.properties || {}).forEach(([key, value]) => {
        if (!value || key.startsWith('_')) return;
        const property = document.createElement('p');
        property.className = 'rb-detail';
        property.textContent = `${key}: ${value}`;
        content.appendChild(property);
      });
      const price = document.createElement('p');
      price.className = 'rb-price';
      price.textContent = `${money(item.final_price)} each · ${money(item.final_line_price)} total`;
      content.appendChild(price);
      const controls = document.createElement('div');
      controls.className = 'rb-controls';
      const quantity = document.createElement('div');
      quantity.className = 'rb-quantity';
      const rule = item.quantity_rule || {};
      const step = rule.increment || 1;
      const minimum = rule.min || 1;
      function changeButton(label, text, amount, type) {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = text;
        button.setAttribute('aria-label', label);
        button.dataset.rbChange = 'true';
        button.dataset.rbFocus = `${item.key}:${type}`;
        button.disabled = busy;
        button.addEventListener('click', () => { changeQuantity(item.key, amount); });
        return button;
      }
      quantity.appendChild(changeButton(`Decrease quantity of ${item.product_title}`, '−',
        item.quantity <= minimum ? 0 : Math.max(minimum, item.quantity - step), 'minus'));
      const count = document.createElement('span');
      count.textContent = item.quantity;
      count.setAttribute('aria-label', `Quantity ${item.quantity}`);
      quantity.appendChild(count);
      const plus = changeButton(`Increase quantity of ${item.product_title}`, '+', item.quantity + step, 'plus');
      if (rule.max != null && item.quantity + step > rule.max) {
        plus.disabled = true;
        plus.dataset.rbLimit = 'true';
      }
      quantity.appendChild(plus);
      controls.appendChild(quantity);
      const remove = changeButton(`Remove ${item.product_title}`, 'Remove', 0, 'remove');
      remove.className = 'rb-remove';
      controls.appendChild(remove);
      content.appendChild(controls);
      row.appendChild(content);
      items.appendChild(row);
    });
    if (focusKey && !drawer.hidden) {
      const replacement = Array.from(drawer.querySelectorAll('[data-rb-focus]'))
        .find(element => element.dataset.rbFocus === focusKey);
      if (replacement && !replacement.disabled) replacement.focus();
      else drawer.querySelector('.rb-close').focus();
    }
  }
  async function refreshCart() {
    const cart = await request('cart.js');
    renderCart(cart);
    return cart;
  }
  async function changeQuantity(key, quantity) {
    if (busy) return;
    setBusy(true);
    setMessage('Updating your bag…');
    try {
      const cart = await request('cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      setBusy(false);
      renderCart(cart);
      showSuccessNotice('Your bag has been updated.');
    } catch (error) {
      setMessage(error.message);
      try { await refreshCart(); }
      catch { setMessage(message.textContent + ' Refresh the page to check your bag.'); }
    } finally { setBusy(false); }
  }
  drawer.addEventListener('click', event => {
    if (event.target.closest('[data-rb-close]')) closeDrawer();
    if (busy && event.target.closest('.rb-checkout')) {
      event.preventDefault();
      setMessage('Please wait for your bag to finish updating.');
    }
  });
  document.addEventListener('keydown', event => {
    if (drawer.hidden) return;
    if (event.key === 'Escape') {
      event.preventDefault(); closeDrawer(); return;
    }
    if (event.key !== 'Tab') return;
    const focusable = Array.from(panel.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex="0"]'
    )).filter(element => element.getClientRects().length);
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (!first) { event.preventDefault(); panel.focus(); }
    else if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
      event.preventDefault(); last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault(); first.focus();
    }
  });

  // One delegated click handler covers the new quantity controls and existing bag link.
  document.addEventListener('click', async event => {
    const quantityButton = event.target.closest('#first-drop [data-republic-quantity]');
    if (quantityButton) {
      if (busy || quantityButton.disabled) return;
      const form = quantityButton.closest('form');
      const input = form?.querySelector('.republic-quantity input[name="quantity"]');
      if (!input) return;
      const minimum = Math.max(1, Number(input.min) || 1);
      const maximum = input.max === '' ? Infinity : Number(input.max);
      if (maximum < minimum) { syncDropQuantity(form); return; }
      if (!Number.isFinite(input.valueAsNumber) || input.valueAsNumber < minimum) {
        input.value = String(minimum);
      }
      if (quantityButton.dataset.republicQuantity === '1') input.stepUp();
      else if (input.valueAsNumber > minimum) input.stepDown();
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      syncDropQuantity(form);
      return;
    }
    const link = event.target.closest('header a[aria-label="Shopping bag"]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    openDrawer();
    if (busy) return;
    setBusy(true);
    setMessage('Loading your bag…');
    try { await refreshCart(); setMessage(''); }
    catch (error) { setMessage(error.message); }
    finally { setBusy(false); }
  });
  document.addEventListener('input', event => {
    if (event.target.matches('#first-drop .republic-quantity input')) syncDropQuantity(event.target.form);
  });
  document.addEventListener('change', event => {
    if (event.target.matches('#first-drop select[name="id"], #first-drop .republic-quantity input')) {
      syncDropQuantity(event.target.form);
    }
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = new URL(form.action, location.origin);
    if (action.origin !== location.origin || !/\/cart\/add(?:\.js)?\/?$/.test(action.pathname)) return;
    event.preventDefault();
    if (busy || !form.reportValidity()) return;
    const formData = new FormData(form);
    const buttons = Array.from(form.querySelectorAll('button[type="submit"], button:not([type]), input[type="submit"]'));
    const buttonStates = buttons.map(button => button.disabled);
    const status = form.querySelector('[data-status]');
    setBusy(true);
    buttons.forEach(button => { button.disabled = true; });
    if (status) { status.hidden = false; status.textContent = 'Adding to your bag…'; }
    let added = false;
    try {
      await request('cart/add.js', { method: 'POST', body: formData });
      added = true;
      openDrawer();
      setMessage('Updating your bag…');
      await refreshCart();
      showSuccessNotice('Added to your bag.', status);
    } catch (error) {
      const text = added ? 'Your item was added, but the bag could not refresh. Refresh the page before adding it again.' : error.message;
      if (status) { status.hidden = false; status.textContent = text; }
      openDrawer();
      setMessage(text);
    } finally {
      setBusy(false);
      buttons.forEach((button, index) => {
        const selectedVariant = form.querySelector('select[name="id"]')?.selectedOptions[0];
        if (button.matches('[data-add]') && selectedVariant?.dataset.available) {
          button.disabled = selectedVariant.dataset.available !== 'true';
        } else { button.disabled = buttonStates[index]; }
      });
    }
  });
  function init(root = document) {
    root.querySelectorAll('[data-gallery]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const main = gallery.querySelector('.main-image');
      const thumbs = Array.from(gallery.querySelectorAll('[data-thumb]'));
      let index = Math.max(0, thumbs.findIndex(thumb => thumb.getAttribute('aria-pressed') === 'true'));
      function show(next) {
        if (!thumbs.length || !main) return;
        index = (next + thumbs.length) % thumbs.length;
        main.removeAttribute('srcset');
        main.src = thumbs[index].dataset.src;
        main.alt = thumbs[index].dataset.alt;
        thumbs.forEach((thumb, position) => { thumb.setAttribute('aria-pressed', String(index === position)); });
      }
      thumbs.forEach((thumb, position) => { thumb.addEventListener('click', () => show(position)); });
      gallery.querySelector('[data-prev]')?.addEventListener('click', () => show(index - 1));
      gallery.querySelector('[data-next]')?.addEventListener('click', () => show(index + 1));
    });
    root.querySelectorAll('[data-product]').forEach(product => {
      if (product.dataset.ready) return;
      product.dataset.ready = 'true';
      const form = product.querySelector('form');
      const select = form?.querySelector('select');
      const button = form?.querySelector('[data-add]');
      const status = form?.querySelector('[data-status]');
      if (!select || !button) return;
      select.addEventListener('change', () => {
        const variant = select.selectedOptions[0];
        if (!variant) return;
        const quantity = form.querySelector('[name="quantity"]');
        if (quantity) {
          quantity.min = variant.dataset.min || '1';
          quantity.step = variant.dataset.step || '1';
          if (variant.dataset.max) quantity.max = variant.dataset.max;
          else quantity.removeAttribute('max');
          quantity.value = quantity.min;
        }
        const price = product.querySelector('[data-price]');
        if (price) price.textContent = variant.dataset.price;
        button.disabled = busy || variant.dataset.available !== 'true';
        button.textContent = variant.dataset.available !== 'true' ? 'SOLD OUT' : 'ADD TO BAG →';
        if (status) { status.textContent = ''; status.hidden = true; }
        const image = product.closest('.split')?.querySelector('.main-image');
        if (image && variant.dataset.image) {
          image.removeAttribute('srcset');
          image.src = variant.dataset.image;
        }
        syncDropQuantity(form);
      });
      syncDropQuantity(form);
    });
    syncAllDropQuantities();
  }
  init();
  document.addEventListener('shopify:section:load', event => { init(event.target); });
})();